import { render } from "./imageDrawRect5.vue?vue&type=template&id=08d16f40"
import script from "./imageDrawRect5.vue?vue&type=script&lang=js"
export * from "./imageDrawRect5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__